module.exports = "#main-contact {\n  margin-top: 8em;\n}\n\n#contact-footer {\n  box-shadow: 0 0 0 0 !important;\n}\n"